module.exports = __webpack_public_path__ + "img/Home_Tablet_01.4125b945.jpg";